// src/pages/Congreso.js

import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { motion, useScroll, useTransform } from 'framer-motion';
import { FiCalendar } from 'react-icons/fi';

import '../styles/Congreso.css';
import { congresosAnterioresData } from '../datosCongresos.js';

import imgFavaloro from '../assets/images/Figuras/favaloro.jpg';
import imgMora from '../assets/images/Figuras/araujo.jpg';
import imgLondono from '../assets/images/Figuras/londoño.jpg';
import imgAlleyne from '../assets/images/Figuras/alleyne.jpg';
import imgSonis from '../assets/images/Figuras/sonis.jpg';
import imgGines from '../assets/images/Figuras/gines.jpg';
import imgPaganini from '../assets/images/Figuras/paganini.jpg';
import imgNeri from '../assets/images/Figuras/neri.jpg';
import imgVarela from '../assets/images/Figuras/varela.jpg';
import imgMoralesSola from '../assets/images/Figuras/sola.jpg';
import imgCongreso from '../assets/images/congreso4.jpg';
import portadaImg from '../assets/images/portada.webp';


// --- DATOS DE LA PÁGINA ---

const historiaDelCongresoTexto = `
  <strong>“SALUD, CRISIS Y REFORMA”</strong><br/><br/>
  El Congreso Internacional “Salud Crisis y Reforma” fue creado por la Cámara Argentina de Empresas de Salud (CAES) en el año 1995, con el claro objetivo de mejorar el nivel sanitario de la comunidad, considerando al Hombre como Eje indiscutido del Sistema.<br/><br/>
  Cuenta con el acompañamiento de los más importantes organismos internacionales, entre ellos: Federación Latinoamericana de Hospitales (FLH), Federación Internacional de Hospitales (FIH), Organización Mundial de la Salud (OMS), Organización Panamericana de la Salud (OPS), Organización Iberoamericana de Servicios de Salud (OISS), Organización Iberoamericana de Prestadores de Servicios de Salud (OIPSS).<br/><br/>
  En su génesis surgió con la idea de constituirse como un ámbito genuino del Sector Salud para discutir y reflexionar sobre política sanitaria y permitir el intercambio entre los distintos actores del Sistema y la sociedad en su conjunto.<br/><br/>
  Hasta su creación no existían espacios destinados al debate multidisciplinario sobre estos temas y quizás a ello se deba el éxito de sus jornadas, que desde un primer momento contaron con una masiva concurrencia de asistentes, así como también con la activa participación en sus paneles de las figuras más destacadas del ámbito nacional e  internacional: expertos de las principales entidades internacionales, funcionarios de primera línea de los distintos gobiernos de turno, legisladores, sanitaristas, economistas, comunicadores.<br/><br/>
  Inicialmente “Salud, Crisis y Reforma” fue el concepto central para dar inicio a los encuentros en momentos difíciles y con la necesidad de encarar una profunda reforma. La crisis y el estado permanente de reforma condicionó a mantener el título inicial incorporando cada año distintos sub-lemas con la necesidad de instalar de manera amplia propuestas de gestión para diversas áreas de la salud: sanitarias, financiación, capacitación, normativas de calidad para los establecimientos y otros factores importantes.<br/><br/>
  Desde el año 2011 se ha decidido federalizar el escenario del Congreso, con el objeto de trasladar el debate a distintas regiones motivando, para propagar la conciencia social en defensa de la salud. Comenzamos con la provincia de Tucumán, luego Entre Ríos y la provincia de Buenos Aires.<br/><br/>
  Además en 2013 se han realizado con gran éxito dos actividades Pre Congreso en las provincias de San Juan y Santiago del Estero, que introdujeron a los asistentes en el tema de las Redes Integradas de Servicios de Salud (RISS), y que contaron con la destacada participación de la OPS, los ministros de Salud locales y referentes de los sectores estatales, privados y de la seguridad social. La necesidad de lograr la participación activa de los concurrentes, que atesoran un conocimiento y experiencia enormes, motivó a la Secretaría Técnica a proponer el trabajo en talleres denominados “Mesas de Trabajo”. No ha sido una sorpresa pero sí una gratificación el comprobar el entusiasmo y el amplio debate generado.<br/><br/>
  A su vez, en diversas oportunidades se llevan adelante actividades complementarias, simultáneas, que permiten un mayor acercamiento de los prestadores entre sí y de estos hacia otros terceros, como proveedores, autoridades y otros organismos.<br/><br/>
  El objetivo es desarrollar políticas efectivas de administración y gestión estratégica para el mejoramiento continuo de los establecimientos de salud, aportando herramientas concretas para optimizar las funciones de todas sus áreas, propuestas para un mejor gobierno de políticas sanitarias que redunden hacia la mayor seguridad de atención hacia el paciente, aportando elementos que contribuyan a reducir las barreras de acceso e inequidad.<br/><br/>
  La organización de este tipo de eventos implica un gran esfuerzo, sobre todo en escenarios tan dinámicos como los que vive nuestro país y el mundo en su conjunto. El Congreso Internacional “Salud, Crisis y Reforma” está avalado por años de impecable trayectoria y trabajo ininterrumpido, y es quizá por el compromiso demostrado y la seriedad de sus propuestas que sigue siendo elegido como escenario indiscutido por el Sector de la Salud.
`;


const personalidadesDestacadas = [
    { nombre: 'Dr. René Favaloro', imagen: imgFavaloro },
    { nombre: 'Lic. Manuel Mora y Araujo', imagen: imgMora },
    { nombre: 'Padre Salazar Londoño', imagen: imgLondono },
    { nombre: 'Dr. George Alleyne', imagen: imgAlleyne },
    { nombre: 'Dr. Abraam Sonis', imagen: imgSonis },
    { nombre: 'Dr. Ginés Gonzales García', imagen: imgGines },
    { nombre: 'Dr. José María Paganini', imagen: imgPaganini },
    { nombre: 'Dr. Aldo Neri', imagen: imgNeri },
    { nombre: 'Dr. Jesús Lopez Varela', imagen: imgVarela },
    { nombre: 'Dr. Joaquín Morales Solá', imagen: imgMoralesSola },
];

// --- COMPONENTE "CONGRESOS ANTERIORES" CON LÍNEA DE TIEMPO ---
const CongresosAnteriores = () => {
    const congresosAgrupados = congresosAnterioresData.reduce((acc, congreso) => {
        const yearMatch = congreso.title.match(/\((\d{4})\)/);
        const year = yearMatch ? yearMatch[1] : 'Sin Fecha';
        if (!acc[year]) acc[year] = [];
        acc[year].push(congreso);
        return acc;
    }, {});

    const anosOrdenados = Object.keys(congresosAgrupados).sort((a, b) => b - a);

    return (
        <section id="congresos-anteriores" className="page-section-congreso alternate-bg" data-aos="fade-up">
            <div className="container-congreso">
                <h2 className="section-title-congreso">Nuestros Congresos</h2>
                <p className="subtitle-section-lemas">Un recorrido por los temas que marcaron la agenda de la salud en Argentina.</p>
                
                <div className="timeline-container">
                    {anosOrdenados.map((ano) => (
                        <div key={ano} className="timeline-year-group" data-aos="fade-up">
                            <div className="timeline-year-marker">
                                <FiCalendar />
                                <span>{ano}</span>
                            </div>
                            <div className="timeline-events">
                                {congresosAgrupados[ano].map((congreso, index) => (
                                    <div key={congreso.id} className="timeline-card" data-aos="fade-up" data-aos-delay={index * 100}>
                                        <div className="timeline-card-header">
                                            <span className="timeline-card-edition">{congreso.title.split(' ')[0]}</span>
                                            <h4 className="timeline-card-title">{congreso.title.replace(/\(\d{4}\)/, '').replace(congreso.title.split(' ')[0], '')}</h4>
                                        </div>
                                        {congreso.lema && (
                                            <div className="timeline-card-body">
                                                <p className="timeline-card-lema">"{congreso.lema}"</p>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};


const HistoriaCongreso = () => (
    <section id="historia-congreso" className="page-section-congreso" data-aos="fade-up">
        <div className="container-congreso">
            <h2 className="section-title-congreso">Historia del Congreso</h2>
            <div className="content-box-congreso">
                <div dangerouslySetInnerHTML={{ __html: historiaDelCongresoTexto }} />
                   <div className="image-box" data-aos="fade-left">
                       <img src={imgCongreso} alt="Reunión de profesionales de la salud" />
                    </div>
                     <div className="personalidades-section">
                        <h3 className="section-subtitle-congreso">Personalidades Destacadas que Participaron</h3>
                        <div className="personalidades-grid">
                            {personalidadesDestacadas.map((persona, index) => (
                                <div key={index} className="person-card" data-aos="fade-up" data-aos-delay={index * 50}>
                                    <img src={persona.imagen} alt={`Foto de ${persona.nombre}`} className="person-photo"/>
                                    <p className="person-name">{persona.nombre}</p>
                                </div>
                            ))}
                        </div>
                    </div>
            </div>
        </div>
    </section>
);

// --- COMPONENTE PRINCIPAL DE LA PÁGINA ---
const Congreso = () => {
    const location = useLocation();
    const [activeSection, setActiveSection] = useState('congreso');
    
    const containerRef = useRef(null);
    const { scrollYProgress } = useScroll({
        target: containerRef,
        offset: ["start start", "end start"]
    });
    const parallaxY = useTransform(scrollYProgress, [0, 1], ["0%", "20%"]);

    useEffect(() => {
        AOS.init({
            duration: 800,
            once: true,
            easing: 'ease-in-out',
        });
    }, []);

    useEffect(() => {
        const hash = location.hash.replace('#', '');
        if (hash) {
            setActiveSection(hash);
            window.scrollTo(0, 0); 
        } else {
            setActiveSection('congreso');
            window.scrollTo(0, 0); 
        }
    }, [location]);

    const renderSection = () => {
        switch (activeSection) {
            case 'historia-congreso':
                return <HistoriaCongreso />;
            case 'congreso':
            default:
                return <CongresosAnteriores />;
        }
    };

    return (
        <div className="congreso-page-container" ref={containerRef}>
            <motion.div
              className="congreso-background-image"
              style={{ 
                backgroundImage: `url(${portadaImg})`,
                y: parallaxY 
              }}
            />
            <main className="main-content-congreso">
                {renderSection()}
            </main>
        </div>
    );
};

export default Congreso;